import lodash from "lodash";
import { defineAsyncComponent } from "vue";
import {
    createFieldAttachment,
    createFieldImage
} from "../../../components/input/template-builder/template-builder.logic";
import i18n from "../../../i18n";
import store from "../../../store";
import { conditionFormChecker, putField } from "../../../utils/form";
import { createFormAttachment } from "./user-signature.logic";

const UserCaList = defineAsyncComponent(() => import("../company/mgt-tab/tab-7/UserCaList"));
const CardBorder = defineAsyncComponent(() => import("../../../components/card/CardBorder"));

export const callUser = ({ searchQuery }) => {
    const where = [
        { name: "isActive", type: "Boolean", operator: "=", value: true },
        { name: "isTemp", type: "Boolean", operator: "=", value: false },
        { name: "refPersonType.key", type: "String", operator: "=", value: "2" },
        { name: "refOfficerLv.id", type: "UUID", operator: "!=", value: null }
    ];
    if (searchQuery) {
        where.push({ name: "fullNameTh", type: "String", operator: "like", value: searchQuery });
    }
    return store
        .dispatch("resource/v1/security/user/search", {
            criteria: {
                select: ["id", "version", "fullNameTh"],
                page: 0,
                size: 1000000,
                where,
                sort: [{ name: "fullNameTh", type: "ASC" }],
                children: []
            }
        })
        .then(page => page.data);
};

export const createColumns = () => {
    return [];
};

export const createField = ({ props, data, key }) => {
    const { viewOnly, menuContext } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    const userInfo = store.state.resource.auth.info?.user;
    return putField({
        data,
        fields: [
            createFieldImage({
                visible: () => !model.attachments?.[0]?.isDelete && model.attachments?.[0]?.url || model.attachments?.[0]?.blob,
                key: `${prefix}attachments.0`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 6, xl: 4 } }),
                label: () => i18n.global.t("views.attachment.preview"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.attachments?.[0],
                            group: "Image",
                            disabled: true,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldAttachment({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}attachments.0`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("views.attachment.uploadSignature"),
                inputProp: ({ field }) => {
                    return lodash.merge(
                        {
                            value: model.attachments?.[0]?.url || model.attachments?.[0]?.blob ? model.attachments?.[0] : null,
                            "onUpdate:value": value => {
                                if (value && !model.attachments?.length) {
                                    const attachment = createFormAttachment();
                                    model.attachments.push(attachment);
                                }
                                const refAttach = model.attachments?.[0];
                                if (refAttach) {
                                    refAttach.name = value?.name;
                                    refAttach.documentName = refAttach.documentName ? refAttach.documentName : value?.name;
                                    refAttach.blob = value?.blob;
                                    refAttach.isSave = value?.isSave;
                                    refAttach.isDelete = !value;
                                    refAttach.size = value?.size;
                                    refAttach.type = value?.type;
                                    refAttach.model = "User";
                                    refAttach.group = "Signature";
                                }
                                if (!value && !model.attachments?.[0]?.id && model.attachments?.length > 0) {
                                    model.attachments = [];
                                }
                            },
                            disabled: viewOnly,
                            fileListShowMode: "horizontal",
                            accept: "image/*"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field, model } })
                    );
                }
            }),
            {
                visible: () => userInfo.refDepartment?.id,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24 }, wrapperCol: { xs: 24 } }),
                inputRender: () => (<hr/>)
            },
            createFieldImage({
                visible: () => userInfo.refDepartment?.id && !model.attachmentEns?.[0]?.isDelete && model.attachmentEns?.[0]?.url || model.attachmentEns?.[0]?.blob,
                key: `${prefix}attachmentEns.0`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 6, xl: 4 } }),
                label: () => i18n.global.t("views.attachment.previewEn"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.attachmentEns?.[0],
                            group: "Image",
                            disabled: true,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldAttachment({
                visible: ({ field }) => userInfo.refDepartment?.id && conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}attachmentEns.0`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("views.attachment.uploadSignatureEn"),
                inputProp: ({ field }) => {
                    return lodash.merge(
                        {
                            value: model.attachmentEns?.[0]?.url || model.attachmentEns?.[0]?.blob ? model.attachmentEns?.[0] : null,
                            "onUpdate:value": value => {
                                if (value && !model.attachmentEns?.length) {
                                    const attachment = createFormAttachment();
                                    model.attachmentEns.push(attachment);
                                }
                                const refAttach = model.attachmentEns?.[0];
                                if (refAttach) {
                                    refAttach.name = value?.name;
                                    refAttach.documentName = refAttach.documentName ? refAttach.documentName : value?.name;
                                    refAttach.blob = value?.blob;
                                    refAttach.isSave = value?.isSave;
                                    refAttach.isDelete = !value;
                                    refAttach.size = value?.size;
                                    refAttach.type = value?.type;
                                    refAttach.model = "User";
                                    refAttach.group = "SignatureEn";
                                }
                                if (!value && !model.attachmentEns?.[0]?.id && model.attachmentEns?.length > 0) {
                                    model.attachmentEns = [];
                                }
                            },
                            disabled: viewOnly,
                            fileListShowMode: "horizontal",
                            accept: "image/*"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field, model } })
                    );
                }
            }),
            {
                visible: () => true,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24 }, wrapperCol: { xs: 24 } }),
                inputRender: () => (<div className="text-center text-primary">{ i18n.global.t(`views.attachment.remark`)}</div>)
            },
            {
                visible: () => true,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24 }, wrapperCol: { xs: 24 } }),
                inputRender: () => {
                    const cardProp = lodash.merge(
                        {
                            title: i18n.global.t("views.company.mgt.tab.7.card2")
                        },
                        conditionFormChecker({ props, data, executeKey: "cardProp", params: { componentKey: "UserCaList" } })
                    );
                    const componentProp = lodash.merge(
                        {
                            menuContext: menuContext,
                            viewOnly: viewOnly,
                            dataProp: data,
                            itemsKey: `${prefix}userCas`,
                            fetchCriteria: data.userCa?.fetchCriteria,
                            canCreate: !viewOnly,
                            canDelete: !viewOnly,
                            isFillPassword: true,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { componentKey: "UserCaList" } })
                    );
                    return (
                        <CardBorder class="mt-4" {...cardProp}>
                            <UserCaList {...componentProp}></UserCaList>
                        </CardBorder>
                    );
                }
            }
        ]
    });
};
